import React from 'react';
import { useGameStore } from '../stores/gameStore';
import { formatNumber, formatRate, getTierDef } from '@annopolis/shared';

export function ResourceBar() {
  const { save, rates } = useGameStore();
  const tierDef = getTierDef(save.tier);
  const res = save.resources;
  const labels = tierDef?.resources ?? { primary: 'Matter', knowledge: 'Knowledge', energy: 'Energy', pvp: 'Influence' };

  return (
    <header style={styles.bar}>
      <div style={styles.tierLabel}>
        <span style={styles.tierName}>{tierDef?.name ?? 'Annopolis'}</span>
        <span style={styles.tierNum}>TIER {save.tier}</span>
      </div>

      <div style={styles.resources}>
        <ResourcePip
          label={labels.primary}
          value={res.primary}
          rate={rates.primaryPerSec}
          color="#4af0c4"
        />
        <ResourcePip
          label={labels.knowledge}
          value={res.knowledge}
          rate={rates.knowledgePerSec}
          color="#a78bfa"
        />
        <ResourcePip
          label={labels.energy}
          value={res.energy}
          rate={rates.energyPerSec}
          color="#fbbf24"
        />
        <ResourcePip
          label={labels.pvp}
          value={res.pvp}
          rate={rates.pvpPerSec}
          color="#f87171"
        />
      </div>

      <div style={styles.meta}>
        {save.ascensions > 0 && (
          <span style={styles.ascTag}>✦ {save.ascensions} ASC</span>
        )}
      </div>
    </header>
  );
}

function ResourcePip({
  label, value, rate, color,
}: { label: string; value: number; rate: number; color: string }) {
  return (
    <div style={styles.pip}>
      <span style={{ ...styles.pipLabel, color }}>{label}</span>
      <span style={styles.pipValue}>{formatNumber(value)}</span>
      <span style={{ ...styles.pipRate, color: `${color}99` }}>+{formatRate(rate)}</span>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    background: 'rgba(10,14,26,0.95)',
    borderBottom: '1px solid rgba(74,240,196,0.2)',
    backdropFilter: 'blur(8px)',
    height: 52,
    gap: 12,
    zIndex: 100,
  },
  tierLabel: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 140,
  },
  tierName: {
    fontSize: 11,
    color: '#4af0c4',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontWeight: 600,
  },
  tierNum: {
    fontSize: 10,
    color: '#4a6080',
    letterSpacing: '0.08em',
  },
  resources: {
    display: 'flex',
    gap: 24,
    flex: 1,
    justifyContent: 'center',
  },
  pip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 80,
  },
  pipLabel: {
    fontSize: 9,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontWeight: 600,
  },
  pipValue: {
    fontSize: 14,
    fontWeight: 700,
    color: '#e0e8ff',
    lineHeight: 1.2,
  },
  pipRate: {
    fontSize: 10,
  },
  meta: {
    minWidth: 80,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ascTag: {
    fontSize: 11,
    color: '#fbbf24',
    fontWeight: 600,
    letterSpacing: '0.05em',
  },
};
